import { useEffect, useState } from 'react';

// Hook to allow bypassing of Toga limitation on SSR, which requires being rendered clientside only.
// https://github.com/vercel/next.js/issues/6817#issuecomment-659234654
const useMounted = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);

  return mounted;
};

export default useMounted;
